import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    brandName: Yup.string()
      .required("common:validator.required")
      .max(50, { code: "common:validator.maxChars", params: { max: 50 } }),
  });
};
